import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService, HttpBaseService, LocalizationService, NotifyService } from '@app/core';
import { ApiControllerEnum, EntityStateEnum } from '@app/shared/common/enums';
import { AnswerListItem, AnswerWithChoiceListItem, AnswerWithContentAndChoiceListItem, AnswerWithContentListItem } from '../models/answer-list-item';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnswerService extends HttpBaseService{

  constructor(private http: HttpClient
    , private notifyServ: NotifyService
    , private localizationService: LocalizationService
    , private configService: ConfigurationService) {
    super(http, ApiControllerEnum.Answer, notifyServ, localizationService, configService);
  }

  getDataByFilter(filter: any): Observable<AnswerWithContentAndChoiceListItem> {
    return this.post("getDataByFilter", filter, true);
  }

  getAnswerByFilter(filter: any): Observable<any> {
    return this.post("GetAnswerByFilter", filter, true,false);
  }
  getAnswerContentIdByFilter(filter: any): Observable<any> {
    return this.post("GetAnswerContentIdByFilter", filter, true,false);
  }

}
